import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

function BarcodeEan13Svg({ style = {width: "300px", height: "180px"}, color = "primary", viewBox = "0 0 474.000000 210.000000" }) {
    return (
        <SvgIcon color={color} style={style} viewBox={viewBox}>
            <g transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)"
                fill="#000000" stroke="none">
                <path d="M390 1135 c0 -958 0 -965 20 -965 20 0 20 7 20 965 0 958 0 965 -20
                965 -20 0 -20 -7 -20 -965z"/>
                <path d="M470 1135 c0 -958 0 -965 20 -965 20 0 20 7 20 965 0 958 0 965 -20
                965 -20 0 -20 -7 -20 -965z"/>
                <path d="M600 1220 l0 -880 40 0 40 0 0 880 0 880 -40 0 -40 0 0 -880z"/>
                <path d="M760 1220 c0 -873 0 -880 20 -880 20 0 20 7 20 880 0 873 0 880 -20
                880 -20 0 -20 -7 -20 -880z"/>
                <path d="M890 1220 l0 -880 60 0 60 0 0 880 0 880 -60 0 -60 0 0 -880z"/>
                <path d="M1050 1220 l0 -880 25 0 25 0 0 880 0 880 -25 0 -25 0 0 -880z"/>
                <path d="M1140 1220 l0 -880 40 0 40 0 0 880 0 880 -40 0 -40 0 0 -880z"/>
                <path d="M1300 1220 l0 -880 45 0 45 0 0 880 0 880 -45 0 -45 0 0 -880z"/>
                <path d="M1470 1220 l0 -880 65 0 65 0 0 880 0 880 -65 0 -65 0 0 -880z"/>
                <path d="M1640 1220 c0 -873 0 -880 20 -880 20 0 20 7 20 880 0 873 0 880 -20
                880 -20 0 -20 -7 -20 -880z"/>
                <path d="M1760 1220 l0 -880 45 0 45 0 0 880 0 880 -45 0 -45 0 0 -880z"/>
                <path d="M1930 1220 c0 -873 0 -880 20 -880 20 0 20 7 20 880 0 873 0 880 -20
                880 -20 0 -20 -7 -20 -880z"/>
                <path d="M2100 1220 c0 -873 0 -880 20 -880 20 0 20 7 20 880 0 873 0 880 -20
                880 -20 0 -20 -7 -20 -880z"/>
                <path d="M2180 1220 l0 -880 40 0 40 0 0 880 0 880 -40 0 -40 0 0 -880z"/>
                <path d="M2300 1135 l0 -965 25 0 25 0 0 965 0 965 -25 0 -25 0 0 -965z"/>
                <path d="M2390 1135 c0 -958 0 -965 20 -965 20 0 20 7 20 965 0 958 0 965 -20
                965 -20 0 -20 -7 -20 -965z"/>
                <path d="M2470 1220 l0 -880 65 0 65 0 0 880 0 880 -65 0 -65 0 0 -880z"/>
                <path d="M2640 1220 c0 -873 0 -880 20 -880 20 0 20 7 20 880 0 873 0 880 -20
                880 -20 0 -20 -7 -20 -880z"/>
                <path d="M2760 1220 l0 -880 65 0 65 0 0 880 0 880 -65 0 -65 0 0 -880z"/>
                <path d="M2930 1220 c0 -873 0 -880 20 -880 20 0 20 7 20 880 0 873 0 880 -20
                880 -20 0 -20 -7 -20 -880z"/>
                <path d="M3060 1220 l0 -880 60 0 60 0 0 880 0 880 -60 0 -60 0 0 -880z"/>
                <path d="M3220 1220 c0 -873 0 -880 20 -880 20 0 20 7 20 880 0 873 0 880 -20
                880 -20 0 -20 -7 -20 -880z"/>
                <path d="M3350 1220 l0 -880 60 0 60 0 0 880 0 880 -60 0 -60 0 0 -880z"/>
                <path d="M3510 1220 l0 -880 25 0 25 0 0 880 0 880 -25 0 -25 0 0 -880z"/>
                <path d="M3640 1220 c0 -873 0 -880 20 -880 20 0 20 7 20 880 0 873 0 880 -20
                880 -20 0 -20 -7 -20 -880z"/>
                <path d="M3720 1220 c0 -873 0 -880 20 -880 20 0 20 7 20 880 0 873 0 880 -20
                880 -20 0 -20 -7 -20 -880z"/>
                <path d="M3930 1220 c0 -873 0 -880 20 -880 20 0 20 7 20 880 0 873 0 880 -20
                880 -20 0 -20 -7 -20 -880z"/>
                <path d="M4060 1220 c0 -873 0 -880 20 -880 20 0 20 7 20 880 0 873 0 880 -20
                880 -20 0 -20 -7 -20 -880z"/>
                <path d="M4220 1135 c0 -958 0 -965 20 -965 20 0 20 7 20 965 0 958 0 965 -20
                965 -20 0 -20 -7 -20 -965z"/>
                <path d="M4310 1135 c0 -958 0 -965 20 -965 20 0 20 7 20 965 0 958 0 965 -20
                965 -20 0 -20 -7 -20 -965z"/>
                <path d="M82 264 c-50 -34 -67 -120 -38 -189 37 -89 166 -66 166 30 0 69 -73
                108 -129 68 -24 -16 -24 -16 -17 13 10 44 43 67 88 61 27 -4 38 -1 38 8 0 28
                -72 34 -108 9z m82 -120 c34 -34 9 -94 -39 -94 -48 0 -73 60 -39 94 8 9 26 16
                39 16 13 0 31 -7 39 -16z"/>
                <path d="M618 273 c-10 -2 -18 -11 -18 -20 0 -11 7 -13 30 -8 l30 7 0 -101 0
                -101 -30 0 c-20 0 -30 -5 -30 -15 0 -12 15 -15 75 -15 60 0 75 3 75 15 0 10
                -10 15 -30 15 l-30 0 0 115 0 115 -27 -1 c-16 -1 -36 -3 -45 -6z"/>
                <path d="M923 196 c-69 -110 -69 -116 7 -116 l60 0 0 -30 c0 -20 5 -30 15 -30
                10 0 15 10 15 30 0 23 4 30 20 30 11 0 20 7 20 15 0 8 -9 15 -20 15 -18 0 -20
                7 -20 85 0 81 -1 85 -22 85 -18 0 -35 -19 -75 -84z m64 -83 c-3 -2 -23 -3 -45
                -1 l-41 3 42 67 42 67 3 -66 c2 -36 1 -67 -1 -70z"/>
                <path d="M1188 273 c-10 -2 -18 -11 -18 -20 0 -11 7 -13 30 -8 l30 7 0 -101 0
                -101 -30 0 c-20 0 -30 -5 -30 -15 0 -12 15 -15 75 -15 60 0 75 3 75 15 0 10
                -10 15 -30 15 l-30 0 0 115 0 115 -27 -1 c-16 -1 -36 -3 -45 -6z"/>
                <path d="M1493 196 c-69 -110 -69 -116 7 -116 l60 0 0 -30 c0 -20 5 -30 15
                -30 10 0 15 10 15 30 0 23 4 30 20 30 11 0 20 7 20 15 0 8 -9 15 -20 15 -18 0
                -20 7 -20 85 0 81 -1 85 -22 85 -18 0 -35 -19 -75 -84z m64 -83 c-3 -2 -23 -3
                -45 -1 l-41 3 42 67 42 67 3 -66 c2 -36 1 -67 -1 -70z"/>
                <path d="M1768 273 c-10 -2 -18 -11 -18 -20 0 -11 7 -13 30 -8 l30 7 0 -101 0
                -101 -30 0 c-20 0 -30 -5 -30 -15 0 -12 15 -15 75 -15 60 0 75 3 75 15 0 10
                -10 15 -30 15 l-30 0 0 115 0 115 -27 -1 c-16 -1 -36 -3 -45 -6z"/>
                <path d="M2063 270 c-48 -19 -58 -95 -18 -135 29 -30 79 -33 108 -7 20 17 20
                16 13 -13 -10 -45 -43 -68 -88 -62 -27 4 -38 1 -38 -8 0 -28 72 -34 108 -9 50
                34 67 120 38 189 -21 50 -67 67 -123 45z m81 -36 c9 -8 16 -26 16 -39 0 -13
                -7 -31 -16 -39 -33 -33 -94 -9 -94 36 0 49 61 76 94 42z"/>
                <path d="M2583 270 c-48 -19 -58 -95 -18 -135 29 -30 79 -33 108 -7 20 17 20
                16 13 -13 -10 -45 -43 -68 -88 -62 -27 4 -38 1 -38 -8 0 -28 72 -34 108 -9 50
                34 67 120 38 189 -21 50 -67 67 -123 45z m81 -36 c34 -34 9 -94 -39 -94 -49 0
                -72 55 -38 92 20 22 56 23 77 2z"/>
                <path d="M2863 270 c-48 -19 -58 -95 -18 -135 29 -30 79 -33 108 -7 20 17 20
                16 13 -13 -10 -45 -43 -68 -88 -62 -27 4 -38 1 -38 -8 0 -28 72 -34 108 -9 50
                34 67 120 38 189 -21 50 -67 67 -123 45z m81 -36 c34 -34 9 -94 -39 -94 -49 0
                -72 55 -38 92 20 22 56 23 77 2z"/>
                <path d="M3153 270 c-48 -19 -58 -95 -18 -135 29 -30 79 -33 108 -7 20 17 20
                16 13 -13 -10 -45 -43 -68 -88 -62 -27 4 -38 1 -38 -8 0 -28 72 -34 108 -9 50
                34 67 120 38 189 -21 50 -67 67 -123 45z m81 -36 c34 -34 9 -94 -39 -94 -49 0
                -72 55 -38 92 20 22 56 23 77 2z"/>
                <path d="M3443 270 c-48 -19 -58 -95 -18 -135 29 -30 79 -33 108 -7 20 17 20
                16 13 -13 -10 -45 -43 -68 -88 -62 -27 4 -38 1 -38 -8 0 -28 72 -34 108 -9 50
                34 67 120 38 189 -21 50 -67 67 -123 45z m81 -36 c34 -34 9 -94 -39 -94 -49 0
                -72 55 -38 92 20 22 56 23 77 2z"/>
                <path d="M3742 264 c-50 -34 -67 -120 -38 -189 37 -89 166 -66 166 30 0 69
                -73 108 -129 68 -24 -16 -24 -16 -17 13 10 44 43 67 88 61 27 -4 38 -1 38 8 0
                28 -72 34 -108 9z m82 -120 c34 -34 9 -94 -39 -94 -30 0 -55 25 -55 55 0 30
                25 55 55 55 13 0 31 -7 39 -16z"/>
                <path d="M4025 268 c-41 -23 -47 -66 -15 -98 11 -11 16 -20 11 -20 -19 0 -41
                -32 -41 -60 0 -19 9 -36 26 -49 56 -44 154 -13 154 49 0 28 -22 60 -41 60 -5
                0 0 9 11 20 60 60 -27 142 -105 98z m89 -40 c15 -25 -4 -52 -38 -56 -47 -6
                -74 36 -44 66 18 18 69 11 82 -10z m0 -101 c26 -19 17 -59 -16 -71 -40 -14
                -82 3 -86 34 -7 43 60 67 102 37z"/>
                </g>

        </SvgIcon>
    );
}

export default BarcodeEan13Svg;
